import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment'
import locale from 'element-ui/lib/locale/lang/en'
import './utils/rem'
import './assets/css/common.css'
import ElementUI from 'element-ui'
import VEmojiPicker from 'v-emoji-picker';
Vue.config.productionTip = false;
Vue.use(VEmojiPicker);
import drag from '@/utils/drag.js';
import '@/icons'
import 'element-ui/lib/theme-chalk/index.css'
import '@/permission'
import VueMatomo from 'vue-matomo'
import './cloudcare.js'

Vue.use(VueMatomo, {
  host: 'https://matomo-ml.sangfor.com',
  siteId: process.env.VUE_APP_MATOMO_SITE_ID
})

Vue.config.productionTip = false
Vue.prototype.$moment = moment;
Vue.use(ElementUI,{locale})
Vue.use(drag)
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
//图片点击放大
Viewer.setDefaults({
  title:false//隐藏图片title
  // Options: { 'inline': true, 'button': true, 'navbar': true, 'title': false, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
// 时间格式化过滤器
Vue.filter('dateformat', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

// 须在 $mount 之前注册，供首页等组件 mounted 内调用
window._paq = window._paq || [];
window.matomoCb = function (type, action, name, value) {
  /**
   * type 类别 必填 描述您要跟踪的事件类型
   * action 行动 必填 具体行动
   * name   名称 通常是与之交流的元素的标题
   * value 值
   */
  if (!type && !action) return;
  let arr = [type, action, name, value];
  arr = arr.filter((item) => item);
  window._paq && window._paq.push(arr);
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window._paq.push(['trackPageView']);